<template>
	<section>
        <b-checkbox v-model="checkbox">
        </b-checkbox>
	</section>
</template>
<script>
import { AttributeService } from "@/services/attributes.service";
export default {
	props: [ 'row' ],
    data: () => ({
 		checkbox: null   
    }),
    watch: {
    	checkbox(value, old) {
    		if (old !== null) {
	            AttributeService.attachMandatoryTag({id: this.row.id, value: value}).then(response => {
	               this.$buefy.toast.open({
			          message: "Success",
			          type: "is-info",
			          position: "is-top-right"
			        });
	            });
    		}
    	}
    },
    mounted() {
    	let hasMandatoryTag = this.row.tags.filter(element => element.type == '[SYSTEM][MANDATORY]');
    	this.checkbox = hasMandatoryTag.length ? true : false;
    }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Attributes/_partials/attributeCheckbox.vue